import Timeline from '../components/Timeline';
import LightboxGallery from '../components/LightboxGallery';
import Slider from 'react-slick';
import '../css/weddingPage.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import foto1 from '../images/foto12.jpeg';
import foto2 from '../images/foto2.jpeg';
import foto3 from '../images/foto3.jpeg';
import foto4 from '../images/foto4.jpeg';
import foto5 from '../images/foto5.jpeg';
import foto6 from '../images/foto6.jpeg';
import foto7 from '../images/foto7.jpeg';
import foto8 from '../images/foto8.jpeg';
import foto9 from '../images/foto9.jpeg';
import foto10 from '../images/foto10.jpeg';
import foto11 from '../images/foto11.jpeg';
import foto12 from '../images/foto1.jpeg';
import foto13 from '../images/foto13.jpeg';

export default function DiaDosNamorados() {
  const fotos = [
    foto1, foto2, foto3, foto4, foto5, foto6, foto7, foto8,
    foto9, foto10, foto11, foto12, foto13
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
  };

  return (
    <>
      <section className="story-section">
        <Timeline
          events={[
            { date: '', title: 'Em meados de 2023, o que parecia simplesmente uma relação profissional, mostrou muito mais.' },
            { date: '', title: 'Mostrou que todo caminho possui um propósito, e que a felicidade pode estar mais próxima do que imaginamos.' },
            { date: '', title: 'Após longas conversas diárias, a cada dia revelavam-se coincidências e afinidades que muitas vezes chegavam a assustar, mas ao mesmo tempo provavam que os iguais se atraem sim, e muito!' },
            { date: '', title: 'O primeiro encontro, o primeiro café! Onde a mão tremia e o coração batia acelerado, éramos dois adultos parecendo dois adolescentes. Mal sabíamos, mas ali já havia se iniciado nossa história, que dia após dia, enche cada vez mais nosso peito de amor.' },
            { date: '', title: 'O segundo encontro, o terceiro, o quarto e já estávamos ligados um ao outro. Em nenhum dia deixamos de trocar mensagens e de mostrar nosso sentimento um pelo outro.' },
            { date: '', title: 'E assim que tudo aconteceu... O primeiro abraço, o primeiro beijo, o primeiro EU TE AMO! Cada momento tão especial! Mas, o que mais marcou, foi que em 11/10/23, aconteceu o pedido de namoro.'},
            { date: '', title: 'É oficial! O amor vive! O sim repleto de lágrimas, o novo capítulo que se iniciava. Nenhum deles sabia mais dar passos em frente sem pensar na sua metade. Unidos pelo amor, o caminho era leve, o apoio era mútuo e a certeza de estar no abraço certo era evidente.'},
            { date: '', title: 'Enquanto vivíamos, talvez sem notar, já dividíamos tudo, inclusive o mesmo lar, e juntos descobríamos novos gostos, novas manias e da forma mais natural possível, criávamos nossa vida juntos, com muito respeito, propósitos, amor, diálogo, reciprocidade, crescendo juntos, como uma família realmente deve ser. E, acima de tudo, uma fonte inesgotável de AMOR, a base sólida onde estávamos construindo nosso lar.'},
            { date: '', title: 'Mas ainda faltava algo. 26 de julho de 2025, e Ela disse SIM mais uma vez! Tudo muda, menos a base, O AMOR. Este se multiplica em cada passo, em cada gesto, fica explícito em cada sorriso, em cada toque e em cada beijo e abraço.  É sólido igual rocha e nos impulsiona a formar uma família ainda mais abençoada, agora, por DEUS!'}

          ]}
        />
      </section>

      <section className="gallery-section">
        <h2>Registros do Casal</h2>
        <Slider {...settings}>
          {fotos.map((src, i) => (
            <div key={i} className="slider-img-w">
              <img src={src} alt={`Foto ${i + 1}`} className="slider-img" />
            </div>
          ))}
        </Slider>
        <LightboxGallery images={fotos} className="" />
      </section>
    </>
  );
}
